if (!customElements.get('product-details-accordions')) {
  customElements.define(
    'product-details-accordions',
    class ProductDetailsAccordions extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        const source = this.querySelector('template[data-product-description]');
        const destination = this.querySelector('[data-product-accordion-list]');
        if (!source || !destination) return;

        const sections = {
          description: [],
          benefits: [],
          howToUse: [],
          ingredients: [],
        };
        let activeSection = 'description';

        [...source.content.childNodes].forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) return;

          if (node.nodeType === Node.ELEMENT_NODE && /^H[1-6]$/.test(node.tagName)) {
            const sectionName = this.sectionNameFor(node.textContent);
            if (sectionName) {
              activeSection = sectionName;
              return;
            }
          }

          sections[activeSection].push(node.cloneNode(true));
        });

        this.useExplicitContent(sections, 'benefits', 'template[data-product-benefits]');
        this.useExplicitContent(sections, 'howToUse', 'template[data-product-how-to-use]');
        this.useExplicitContent(sections, 'ingredients', 'template[data-product-ingredients]');

        const fallbackCopy = {
          description: 'Product details are available on the product label.',
          benefits: 'See the product description for product-specific wellness benefits.',
          howToUse: 'Follow the directions on the product label for best results.',
          ingredients: 'Refer to the product label for the complete ingredient list.',
        };

        [
          ['description', 'Description'],
          ['benefits', 'Key Benefits'],
          ['howToUse', 'How to Use'],
          ['ingredients', 'Ingredients'],
        ].forEach(([key, title]) => {
          destination.append(this.buildAccordion(title, sections[key], fallbackCopy[key]));
        });
      }

      sectionNameFor(rawHeading) {
        const heading = rawHeading
          .toLowerCase()
          .replace(/[^\p{L}\p{N}\s]/gu, ' ')
          .replace(/\s+/g, ' ')
          .trim();

        if (heading.includes('ingredient')) return 'ingredients';
        if (
          heading.includes('how to use') ||
          heading.includes('how to enjoy') ||
          heading.includes('direction') ||
          heading.includes('serving suggestion') ||
          heading === 'usage'
        ) {
          return 'howToUse';
        }
        if (heading.includes('benefit') || heading.includes('why you will love')) return 'benefits';
        return null;
      }

      useExplicitContent(sections, key, selector) {
        const template = this.querySelector(selector);
        if (!template || !template.content.textContent.trim()) return;
        sections[key] = [...template.content.childNodes].map((node) => node.cloneNode(true));
      }

      buildAccordion(title, nodes, fallback) {
        const details = document.createElement('details');
        details.className = 'dia-product-accordion';

        const summary = document.createElement('summary');
        summary.className = 'dia-product-accordion__summary';

        const heading = document.createElement('span');
        heading.className = 'dia-product-accordion__title';
        heading.textContent = title;

        const icon = document.createElement('span');
        icon.className = 'dia-product-accordion__icon';
        icon.setAttribute('aria-hidden', 'true');

        const content = document.createElement('div');
        content.className = 'dia-product-accordion__content rte';

        if (nodes.length) {
          nodes.forEach((node) => content.append(node));
        } else {
          const paragraph = document.createElement('p');
          paragraph.textContent = fallback;
          content.append(paragraph);
        }

        summary.append(heading, icon);
        details.append(summary, content);
        return details;
      }
    },
  );
}

const initializeDiaProductGalleries = (root = document) => {
  root.querySelectorAll('media-gallery').forEach((gallery) => {
    if (gallery.dataset.diaGalleryReady === 'true') return;

    const thumbnails = [...gallery.querySelectorAll('.thumbnail-list button.thumbnail')];
    const viewerControls = gallery.querySelector(
      'slider-component[id^="GalleryViewer-"] > .slider-buttons',
    );
    const previousButton = viewerControls?.querySelector('.slider-button--prev');
    const nextButton = viewerControls?.querySelector('.slider-button--next');

    if (thumbnails.length < 2 || !previousButton || !nextButton) return;
    gallery.dataset.diaGalleryReady = 'true';

    const showMedia = (direction) => {
      const activeIndex = Math.max(
        0,
        thumbnails.findIndex((thumbnail) => thumbnail.getAttribute('aria-current') === 'true'),
      );
      const targetIndex = (activeIndex + direction + thumbnails.length) % thumbnails.length;
      thumbnails[targetIndex].click();
    };

    previousButton.addEventListener(
      'click',
      (event) => {
        if (!window.matchMedia('(min-width: 750px)').matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        showMedia(-1);
      },
      true,
    );

    nextButton.addEventListener(
      'click',
      (event) => {
        if (!window.matchMedia('(min-width: 750px)').matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        showMedia(1);
      },
      true,
    );
  });
};

initializeDiaProductGalleries();
document.addEventListener('shopify:section:load', (event) => initializeDiaProductGalleries(event.target));
